const resource = 'sliders'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },

  fetchHome() {
    return $axios.$get('/v2/home-sliders')
  },

  getServiceName: name => 'sliderService',
})
